export const getSelector = <T = any>(path: string) => {
  return (state: Record<string, any> = {}): T => {
    return state[path] || {};
  };
};
